import React from 'react';
import TwitterIcon from '@mui/icons-material/X';
import InstagramIcon from '@mui/icons-material/Instagram';
import IconButton from '@mui/material/IconButton';
import { Box, Tooltip } from '@mui/material';
import GooglePlaySvgIcon from './GooglePlaySvgIcon';
import AppleAppStoreSvgIcon from './AppleAppStoreIcon';

const socialLinks = [
  {
    name: 'X',
    url: 'https://x.com/lcpassage',
    icon: <TwitterIcon fontSize="medium" aria-label="X" />,
  },
  {
    name: 'Instagram',
    url: 'https://www.instagram.com/lakecountypassage/',
    icon: <InstagramIcon fontSize="medium" aria-label="Instagram" />,
  },
  {
    name: 'Apple App Store',
    url: 'https://apps.apple.com/us/app/lake-county-passage/id417250237',
    icon: <AppleAppStoreSvgIcon />,
  },
  {
    name: 'Google Play Store',
    url: 'https://play.google.com/store/apps/details?id=com.lakecountypassage&hl=en_US&pli=1',
    icon: <GooglePlaySvgIcon />, // Remove explicit color to inherit from parent
  },
];

const SocialMedia: React.FC = () => (
  <Box
    sx={{ display: 'flex', gap: 2, alignItems: 'center' }}
    component="nav"
    role="navigation"
    aria-label="Social media links"
  >
    {socialLinks.map(({ name, url, icon }) => (
      <Tooltip title={name} placement="top" key={name}>
        <IconButton
          color="inherit"
          component="a"
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={name}
          size="small"
        >
          {icon}
        </IconButton>
      </Tooltip>
    ))}
  </Box>
);

export default SocialMedia;
